export default __webpack_public_path__ + "static/media/image-search.1e110a10.png";